// Central config for the AKTRA x Éclipse landing page.
// Replace WEEZEVENT_URL with the real Weezevent ticket link when available.

export const CONFIG = {
  brand: "AKTRA",
  eventName: "ÉCLIPSE",
  tagline: "La fin d'été",
  // Event date used for the countdown (update to the real date when confirmed).
  // MUST include an explicit timezone offset (Paris = +02:00 in CEST, +01:00 in CET)
  // otherwise browsers parse it as the visitor's local time.
  eventDate: "2026-09-04T22:00:00+02:00",
  eventTimezone: "Europe/Paris",
  location: "Flow · Paris",
  venue: "Flow",
  city: "Paris",
  venueUrl: "https://flow-paris.paris/",

  // Ticketing (Weezevent) — embedded iframe on the /#billets section.
  // Buttons link to "#billets" so the user stays on-page.
  weezeventUrl: "#billets",
  weezeventEmbedUrl:
    "https://widget.weezevent.com/ticket/E2337725/?code=54496&locale=fr-FR&width_auto=1&color_primary=FF0000",
  weezeventDirectUrl:
    "https://widget.weezevent.com/ticket/E2337725/?code=54496&locale=fr-FR",

  // LemFi partnership
  lemfiUrl: "https://lemfi.com/fr-ca/",
  promoCode: "ECLIPSE",
  promoDiscount: "-30%",

  // Artist links
  nokuji: {
    tiktok: "https://www.tiktok.com/@nokujiii",
    instagram: "https://www.instagram.com/nokuji_",
  },
  founder: {
    name: "C_Dr",
    alias: "Daryl",
  },
};

export const IMAGES = {
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_nokuji-eclipse/artifacts/xi8dhkxp_IMG_0443.jpeg",
  heroEclipse:
    "https://images.unsplash.com/photo-1521893618136-49740c7dd8c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxlY2xpcHNlJTIwbW9vbiUyMGRhcmt8ZW58MHx8fHwxNzg1ODQyNDYyfDA&ixlib=rb-4.1.0&q=85",
  nokuji:
    "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxESiUyMGNvbmNlcnQlMjBkYXJrJTIwbGlnaHRzfGVufDB8fHx8MTc4NTg0MjQ2Mnww&ixlib=rb-4.1.0&q=85",
  crowd:
    "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxwYXJ0eSUyMGNyb3dkJTIwbmlnaHR8ZW58MHx8fHwxNzg1ODQyNDYyfDA&ixlib=rb-4.1.0&q=85",
  redClub:
    "https://images.unsplash.com/photo-1555086156-e6c7353d283f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxyZWQlMjBjbHViJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzg1ODQyNDYxfDA&ixlib=rb-4.1.0&q=85",
};
